import { createSelector } from 'reselect';

import { StoreType } from '@tock/shared/utils/connect';

/**
 * Returns true if the active business uses TACO for inventory management.
 */
export default createSelector(
  (state: StoreType) => state.app?.activeBusiness?.scheduledInventoryConfig,
  (isTaco): boolean => isTaco
);
